<template>
  <div
    class="Re_form_group"
    :class="{'error': hasErrors || (tips && triggerChange)}"
  >
    <label
      class="Re_form_label"
      v-if="label"
      :class="{'form_label': top}"
    >
      {{ label }}
    </label>
    <input
      class="Re_form_control"
      :class="{'form_control': top}"
      :placeholder="top ? null : placeholder"
      :value="value"
      :text="text"
      v-bind="$attrs"
      v-on="listeners"
      @change.native="change"
      :autocomplete="autocomplete"
      :type="$attrs.type || 'text'"
    >
    <p class="tip-error" v-for="(error, index) in errors" :key="index">{{ text || label || placeholder }} {{ error }}</p>
    <p class="tip-error" v-if="triggerChange">{{ tips }}</p>
  </div>
</template>

<script>
  import InputMixin from './input'
  import ValidationMixin from './validation'

  export default {
    mixins: [InputMixin, ValidationMixin],

    methods: {
      change () {
        if (this.triggerChange) {
          this.$emit('change')
        }
      }
    }
  }
</script>

<style lang="scss">
  input:required {
    box-shadow: none;
  }
</style>
